import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { DynamicFormQuestionComponent } from '../../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { QuestionControlService } from '../../../../../inputfileds/form_services/question-control.service';
import { ApiservicesService } from '../../../../../Services/Apis/apiservices.service';
import { DropdownservicesService } from '../../../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { Inputfiledsbase } from '../../../../../inputfileds/models/inputfiledsbase';
import { Observable } from 'rxjs';
import { FrontpageService } from '../../../../../inputfileds/form_services/collegemanagement/frontpage.service';
import { TranslateDirective } from '../../../../Utilites/Directives/translate.directive';
import { TranslatePipe } from '../../../../Utilites/Pipe/translate.pipe';

interface VisionMission {
  uploadDate: string;
  content_type: 'Mission' | 'Vision';
  info: string;
  images: string;
  id: number;
  image_url: string; // Add this line to the interface
  content: string; // Add this line to the interface
}

interface DialogData {
  content_type?: 'missions' | 'visions';
  rowData?: VisionMission;
}

export interface missionVissionModel {
  description: string;
  image_url: File | null;
}

@Component({
    selector: 'app-addmissionvision',
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatDividerModule,
        DynamicFormQuestionComponent,
        MatIconModule,
        TranslateDirective,
        TranslatePipe
    ],
    templateUrl: './addmissionvision.component.html',
    styleUrl: './addmissionvision.component.scss',
    providers: [
        QuestionControlService,
        ApiservicesService,
        DropdownservicesService,
    ]
})
export class AddmissionvisionComponent implements OnInit {
  @Input() createApiEndpoint!: string; // Create API endpoint
  @Input() updateApiEndpoint!: string;
  questions: Inputfiledsbase<string>[] = [];
  questions$: Observable<Inputfiledsbase<any>[]> | null;
  missionVissionForm!: FormGroup;
  datesend!: missionVissionModel;
  missionVisiondata: any = {};
  imageuploaddata: any = {};
  url: string | ArrayBuffer | null | undefined;
  editflag: boolean = false;
  fileName: string | null = null;
  selectedImageUrl: string | ArrayBuffer | null = null; // Changed type
  file: File | null = null; // Changed type
  isButtonLinkEnabled: boolean = false;
  isEditMode: boolean = false; // Add this line

  constructor(
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<AddmissionvisionComponent>,
    Noticesservices: FrontpageService,
    private apiservice: ApiservicesService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.questions$ = Noticesservices.getMissionVissionForm();
    this.selectedImageUrl = `${this.apiservice.environmentPath}/${data.rowData?.image_url}`;
  }

  ngOnInit(): void {
    this.questions$?.subscribe((q) => {
      this.questions = q!; // Assertion operator
      this.cdr.detectChanges();
    });

    this.isEditMode = !!this.data.rowData;

    this.missionVissionForm = this.fb.group({
      content_type: [this.data.content_type || '', Validators.required],
      description: [this.data.rowData?.content || '', Validators.required],
      image_url: [null], // Remove initial value
    });

    if (this.data.rowData?.image_url) {
      this.selectedImageUrl = `${this.apiservice.environmentPath}/${this.data.rowData?.image_url}`;
    }
  }

  onSave(): void {
    const formData = this.missionVissionForm.value;
    this.dialogRef.close(formData);
  }

  onSubmit() {
    if (this.missionVissionForm.invalid) {
      console.error('Form is invalid. Please fix the errors and try again.');
      return;
    }

    const formData = new FormData();
    formData.append('content', this.missionVissionForm.value.description);
    formData.append('content_type', this.missionVissionForm.value.content_type);
    formData.append('website_id', this.data.websiteId);
    formData.append('website_page_id', this.data.pageId);

    if (this.file) {
      formData.append('image_url', this.file);
    }

    if (this.isEditMode) {
      this.updateMissionVission(formData);
    } else {
      this.createMissionVissionData(formData);
    }
  }

  createMissionVissionData(formData: FormData) {
    const editEndpoint = this.data.createApiEndpoint;
    this.apiservice.createMissionVission(editEndpoint, formData).subscribe(
      (res: any) => {
        if (res.code === 200 && res.status === true) {
          this.missionVisiondata = res.data;
          this.missionVissionForm.reset();
          this.closeDialog(true);
        } else {
          console.error(
            'Error creating mission/vision:',
            res.message || 'Unknown error'
          );
        }
      },
      (error: any) => {
        console.error('Error Creating mission/vision:', error);
      }
    );
  }
  updateMissionVission(formData: FormData) {
    if (!this.data.rowData) {
      console.error('Invalid data: rowData or rowData._id is missing.');
      return;
    }
    const endpoint = this.data.updateApiEndpoint;

    this.apiservice
      .updateMissionVission(endpoint, this.data.rowData?.id, formData)
      .subscribe(
        (res: any) => {
          if (res.code === 200 && res.status === true) {
            this.missionVisiondata = res.data;
            this.missionVissionForm.reset();
            this.closeDialog(true);
          } else {
            console.error(
              'Error updating mission/vision:',
              res.message || 'Unknown error'
            );
          }
        },
        (error) => {
          console.error('API Error during edit:', error);
        }
      );
  }

  imageInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files?.length) {
      this.file = input.files[0]; // Store the file
      const reader = new FileReader();

      reader.onload = (e) => {
        this.selectedImageUrl = reader.result as string;
        this.cdr.detectChanges(); // Trigger change detection
      };

      reader.readAsDataURL(this.file);
    }
  }

  closeDialog(success: boolean) {
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.remove('animate__fadeIn');
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.add('animate__fadeOut');
    this.dialogRef.close(success); // Pass success status
  }
}
